import api from "./axios";

export async function getReportCoverage() {
  const response = await api.get("/reports/coverage");
  return response.data;
}

export async function getSalesReportSummary({ period, anchorDate, topLimit = 10 }) {
  const response = await api.get("/reports/sales/summary", {
    params: {
      period,
      anchor_date: anchorDate,
      top_limit: topLimit,
    },
  });
  return response.data;
}

export async function getSalesReportInsights({ period, anchorDate, question = null }) {
  const response = await api.post("/reports/sales/insights", {
    period,
    anchor_date: anchorDate,
    question: question || null,
  });
  return response.data;
}
